<template>
	<div>
		<div class="first_title">Check out</div>
		<div class="detail" v-if="type == 0">
			<div class="product_info">
				<div class="title">Product details</div>
				<div class="info flex align-center">
					<div class="picture">
						<img :src="imgBaseUrl + detail.image" alt="">
					</div>
					<div class="intro">
						<div class="name">{{detail.goods_name}}</div>
						<div class="num">{{detail.num}}</div>
						<div class="price">{{detail.goods_price}}</div>
					</div>
				</div>
			</div>
			<div class="address_info">
				<div class="title">Delivery information</div>
				<div class="address_item">
					<div class="name">Full name：</div>
					<input type="text" v-model="full_name" >
				</div>
				<div class="address_item">
					<div class="name">Delivery address：</div>
					<input type="text" v-model="address">
				</div>
				<div class="address_item">
					<div class="name">Postcode：</div>
					<input type="text" v-model="postal_code">
				</div>
				<div class="address_item">
					<div class="name">Contact number：</div>
					<input type="text" v-model="mobile">
				</div>
				
			</div>
			<div class="order_info">
				<!-- <div class="title">Order Details</div> -->
				<div class="order_item">
					<span>Product Price：</span>
					<span class="val">£{{detail.goods_total_price}}</span>
				</div>
				<div class="order_item">
					<span>Quantity：</span>
					<span class="val">{{detail.num}}</span>
				</div>
				<div class="order_item">
					<span>Order Total：</span>
					<span class="val">£{{detail.goods_total_price}}</span>
				</div>
				<!-- <div class="order_item">
					<span>Shopping Address:</span>
					<input type="text">
				</div> -->
				<div class="submit"  @click="submitOrder">Place order</div>
			</div>
		</div>
		<div class="detail" v-else>
			<div class="product_info">
				<div class="title">Product details</div>
				<div class="info flex align-center" v-for="(item,index) in detail.goods" :key="index">
					<div class="picture">
						<img :src="imgBaseUrl + item.image" alt="">
					</div>
					<div class="intro">
						<div class="name">{{item.goods_name}}</div>
						<div class="num">{{item.num}}</div>
						<div class="price">{{item.goods_total_price}}</div>
					</div>
				</div>
			</div>
			<div class="address_info">
				<div class="title">Delivery information</div>
				<div class="address_item">
					<div class="name">Full name：</div>
					<input type="text" v-model="full_name" >
				</div>
				<div class="address_item">
					<div class="name">Delivery address：</div>
					<input type="text" v-model="address">
				</div>
				<div class="address_item">
					<div class="name">Postcode：</div>
					<input type="text" v-model="postal_code">
				</div>
				<div class="address_item">
					<div class="name">Contact number：</div>
					<input type="text" v-model="mobile">
				</div>
				
			</div>
			<div class="order_info">
				<div class="title">Order Details</div>
				
				<div class="order_item">
					<span>Order Total：</span>
					<span class="val">£{{detail.order_total_amount}}</span>
				</div>
				<div class="submit" @click="submitOrder">Place order</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				id:'',
				number:'',
				cart_id:'',
				detail:{},
				type:0,
				full_name:'',
				mobile:'',
				address:'',
				postal_code:''
			}
		},
		created(){
			this.type = this.$route.query.type;
			if(this.type == 0){
				this.id = this.$route.query.id;
				this.number = this.$route.query.num;
			}else{
				this.cart_id = this.$route.query.cart_id;
			}
			
			
			this.ensureOrder()
		},
		methods:{
			submitOrder(){
				if(this.type == 0){
					var params = {
						num:this.number,
						goods_id:this.id,
						address:this.address,
						full_name:this.full_name,
						mobile:this.mobile,
						postal_code:this.postal_code
					}
					this.$api.post('order/submitOrder',params,res=>{
						if(res.code == 1){
							this.$confirm('Are you sure to place this order ?', 'confirmation', {
							  confirmButtonText: 'Yes',
							  cancelButtonText: 'Cancel',
							  type: 'info'
							}).then(() => {
								this.$api.post('pay/stripe',{order_sn:res.data.order_sn,type:'pc'},res=>{
									if(res.code == 1){
										// this.$message('pay success')
										// this.$router.push('/home/userInfo/orderList')
										location.href=res.data.url
									}
								})
							}).catch(() => {
							  this.$message({
								type: 'info',
								message: 'cancel'
							  });          
							});
							
						}
					})
				}else{
					var params = {
						cart_id:this.cart_id,
						address:this.address,
						full_name:this.full_name,
						mobile:this.mobile,
						postal_code:this.postal_code
					}
					this.$api.post('order/cartSubmitOrder',params,res=>{
						if(res.code == 1){
							this.$confirm('Are you sure to place this order ?', 'confirmation', {
							  confirmButtonText: 'Yes',
							  cancelButtonText: 'Cancel',
							  type: 'info'
							}).then(() => {
								this.$api.post('pay/stripe',{order_sn:res.data.order_sn},res=>{
									if(res.code == 1){
										// this.$message('pay success')
										// this.$router.push('/home/userInfo/orderList')
										location.href=res.data.url
									}
								})
							}).catch(() => {
							  this.$message({
								type: 'info',
								message: 'cancel'
							  });          
							});
						}else{
							this.$message({
								message: res.msg
							});
						}
					})
				}
			},
			ensureOrder(){
				if(this.type == 0){
					var params = {
						num:this.number,
						goods_id:this.id,
					}
					this.$api.post('order/buyNowConfirmOrder',params,res=>{
						if(res.code == 1){
							this.detail = res.data;
						}
					})
				}else{
					var params = {
						cart_id:this.cart_id
					}
					this.$api.post('order/cartConfirmOrder',params,res=>{
						if(res.code == 1){
							this.detail = res.data;
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.first_title{
		font-size: 22px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #282E30;
		width: 1200px;
		margin: 0 auto 20px;
		padding-top: 30px;
	}
	.detail{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin: 0 auto;
		padding: 40px;
		.product_info{
			.title{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				margin-bottom: 30px;
			}
			.info{
				width: 100%;
				padding-bottom: 40px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.picture{
					width: 228px;
					height: 213px;
					background: #282E30;
					border-radius: 10px;
					overflow: hidden;
					flex-shrink: 0;
					// position: absolute;
					// left: 0;
					// top: 0;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.intro{
					width: 100%;
					padding-left: 30px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 50px;
					.num{
						text-align: right;
						margin-top: 20px;
					}
					.price{
						margin-top: 30px;
					}
				}
			}
		}
		.address_info{
			width: 100%;
			padding-bottom: 40px;
			border-bottom: 1px solid #5C707A;
			.title{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				padding-top: 40px;
			}
			.top_info{
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				.address_item{
					width: 50%;
				}
			}
			.address_item{
				display: flex;
				align-items: center;
				width: 100%;
				margin-top: 20px;
				.name{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					flex-shrink: 0;
					width: 180px;
				}
				input{
					width: 80%;
					height: 50px;
					background: #F7F2EB;
					border: 1px solid #282E30;
					border-radius: 10px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #999999;
					line-height: 50px;
				}
			}
		}
		.order_info{
			padding-bottom: 100px;
			.title{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				padding-top: 40px;
			}
			.order_item{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				line-height: 60px;
				display: flex;
				justify-content: flex-end;
				.val{
					color: #BF5F49;
				}
			}
			.submit{
				width: 182px;
				height: 58px;
				background: #5C707A;
				border-radius: 29px;
				text-align: center;
				line-height: 58px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				float: right;
				cursor: pointer;
			}
		}
	}
</style>